/**
 * Promotion plan type ids, mirroring `PromotedPlan.PlanTypeID` in the promotion service
 * (LIVEauctioneers/promotion internal/constants/promotedPlan.go). Only the featured-lots
 * plan types are listed — add others as they're needed.
 */
export enum PromotionPlanTypeId {
    FeaturedLots = 1,
    FeaturedLotsBulk = 9,
}
